// import { getField, updateField } from "vuex-map-fields";
import { httpError } from "@/models/httpError";
import { HTTP } from "@/http-common";
// import {WholesalerDetail} from "../../../models/WholesalerDetail";
const state = {
    // rows: [],
    message: new httpError(),
};
const rows = [];

const getters = {
    // getField,
    getCustomerDetailsArray(){
        // use only getters.bigArray in other getters
        return rows;
    }
};

//Mutations
const mutations = {
    setCustomerDetail(state, wholesalerDetail) {
        // state.filteredRows = customerDetails.filter((x) => x.customerNumber);
        this.rows = wholesalerDetail.data;
    },
    addRow(state) {
        if (state.rows.length > 0) {
            state.rows.push(new WholesalerDetail());
        } else {
            state.rows = [new WholesalerDetail()];
        }
    },
    deleteRow(state) {
        // To enable multi-row form handling
        // we make it possible to add new rows.
        state.rows.pop();
    },
    setProgress(state, message) {
        state.message = message;
    },
    removeRow(state, index) {
        state.rows.splice(index, 1);
    },
    // updateField,
};

//ACTIONS
const actions = {
    bulkUploadVoipServices ({ dispatch }) {
        return new Promise((resolve, reject) => {
            let response = HTTP.post(
                "BulkUpload/bulkUploadVoipServices"
            );
            response
                .then((data) => {
                    dispatch(
                        "setMessage",
                        new httpError({ message: "Updated OK", httpStatus: 200 })
                    );
                    resolve(data);
                })
                .catch((err) => {
                    dispatch(
                        "setMessage",
                        new httpError({
                            message: "Not saved:" + err.message,
                            httpStatus: 500,
                        })
                    );
                    reject(err);
                });
        });
    },
    setMessage({ commit }, message) {
        commit("setProgress", message);
        if (message.httpStatus !== 500)
            setTimeout(() => {
                commit("setProgress", new httpError());
            }, 2000);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
};
